import React, { useState } from 'react';
import './App.css';

function App() {
  const [activeCard, setActiveCard] = useState('recto');

  return (
    <div className="App">
      <header>
        <div className="site-title">AREZKI ANIS BTP</div>
        <nav>
          <ul>
            <li><a href="#accueil" className="active">Accueil</a></li>
            <li><a href="#services">Services</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </nav>
        <div className="logo-container">
          <img src="/images/logo.jpg" alt="ANIS AREZKI BTP Logo" className="logo" />
        </div>
      </header>

      <main>
        <section id="accueil" className="hero fade-in">
          <h1>Ioutichen Arezki Anis</h1>
          <h2>Ingénieur Génie Civil</h2>
          <p>
            Bienvenue chez AREZKI ANIS BTP, votre partenaire de confiance pour tous vos projets de construction et de génie civil.
            Nous proposons des services professionnels adaptés à vos besoins.
          </p>
          <a href="#contact" className="cta-button">Contactez-nous</a>
        </section>

        <section id="business-card" className="business-card-section fade-in">
          <h2>Notre Carte de Visite</h2>
          <div className="business-card-container">
            <div className="card-navigation">
              <button 
                className={`card-nav-button ${activeCard === 'recto' ? 'active' : ''}`}
                onClick={() => setActiveCard('recto')}
              >
                Recto
              </button>
              <button 
                className={`card-nav-button ${activeCard === 'verso' ? 'active' : ''}`}
                onClick={() => setActiveCard('verso')}
              >
                Verso
              </button>
            </div>
            <img 
              src={`/images/business_card_${activeCard === 'recto' ? 'final' : 'verso'}.png`} 
              alt={`Carte de visite ${activeCard}`} 
              className="business-card"
            />
          </div>
        </section>

        <section id="services" className="services-section fade-in">
          <h2>Nos Services</h2>
          <div className="services-list">
            <div className="service-item">
              <div className="service-icon">📐</div>
              <h3 className="service-title">Étude et dessin génie civil</h3>
              <p className="service-description">
                Conception et réalisation de plans détaillés pour vos projets de construction, 
                avec une expertise technique approfondie en génie civil.
              </p>
            </div>
            <div className="service-item">
              <div className="service-icon">👷</div>
              <h3 className="service-title">Conseil et visite du chantier</h3>
              <p className="service-description">
                Accompagnement personnalisé sur site avec conseils d'expert pour assurer 
                la conformité et la qualité de vos travaux.
              </p>
            </div>
            <div className="service-item">
              <div className="service-icon">💰</div>
              <h3 className="service-title">Calcul consommation et prix du chantier</h3>
              <p className="service-description">
                Estimation précise des coûts et des ressources nécessaires pour votre projet, 
                avec optimisation budgétaire.
              </p>
            </div>
            <div className="service-item">
              <div className="service-icon">🏗️</div>
              <h3 className="service-title">Réalisation CES</h3>
              <p className="service-description">
                Mise en œuvre professionnelle de Cahiers des Entrées et Sorties pour 
                une gestion rigoureuse de votre projet.
              </p>
            </div>
          </div>
        </section>

        <section id="contact" className="contact-section fade-in">
          <h2>Contactez-nous</h2>
          <div className="contact-grid">
            <div className="contact-item">
              <div className="contact-icon">📱</div>
              <div className="contact-info">
                <h3>Téléphone</h3>
                <p><a href="tel:+213541760654">+213 541760654</a></p>
              </div>
            </div>
            <div className="contact-item">
              <div className="contact-icon">✉️</div>
              <div className="contact-info">
                <h3>Email</h3>
                <p><a href="mailto:Arezki.anis24@gmail.com">Arezki.anis24@gmail.com</a></p>
              </div>
            </div>
          </div>
        </section>

        <section className="qr-codes-section fade-in">
          <h2>Retrouvez-nous en ligne</h2>
          <div className="qr-codes-grid">
            <div className="qr-code-item">
              <img src="/images/qr_telegram.png" alt="QR Code Telegram" className="qr-code" />
              <span className="qr-label">Telegram</span>
            </div>
            <div className="qr-code-item">
              <img src="/images/qr_linkedin.png" alt="QR Code LinkedIn" className="qr-code" />
              <span className="qr-label">LinkedIn</span>
            </div>
            <div className="qr-code-item">
              <img src="/images/qr_whatsapp.png" alt="QR Code WhatsApp" className="qr-code" />
              <span className="qr-label">WhatsApp</span>
            </div>
          </div>
        </section>
      </main>

      <footer>
        <div className="footer-content">
          <div className="site-title">AREZKI ANIS BTP</div>
          <div className="footer-links">
            <a href="#accueil">Accueil</a>
            <a href="#services">Services</a>
            <a href="#contact">Contact</a>
          </div>
          <p className="copyright">© {new Date().getFullYear()} AREZKI ANIS BTP. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
